// Fallback usado onde não há curso no contexto (ex.: UpgradeCTA) — data
// oficial da prova da Polícia Penal RS.
const DEFAULT_EXAM_DATE = new Date(2026, 7, 9); // mês é 0-indexado: 7 = agosto

// 'YYYY-MM-DD' vira Date à meia-noite local (não UTC) — parsear via
// new Date(string) trataria a data como UTC e deslocaria o dia em fusos
// positivos (ex.: exam_date '2026-08-09' viraria 08/08 à noite em alguns
// fusos). Parsear os componentes manualmente evita esse problema.
function parseExamDate(examDate) {
  if (!examDate) return DEFAULT_EXAM_DATE;
  if (examDate instanceof Date) return examDate;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(examDate);
  if (!match) return DEFAULT_EXAM_DATE;
  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day));
}

// Retorna quantos dias faltam para a prova (0 no dia, null se já passou).
// `examDate` aceita string 'YYYY-MM-DD' (vinda do curso) ou Date; se
// omitido, usa a data padrão acima.
export function getDaysUntilExam(examDate) {
  const target = parseExamDate(examDate);
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffDays = Math.ceil((target - startOfToday) / (1000 * 60 * 60 * 24));
  return diffDays >= 0 ? diffDays : null;
}

// Formata 'YYYY-MM-DD' como 'DD/MM/AAAA' sem passar por Date/fuso horário.
export function formatExamDate(examDate) {
  if (!examDate) return '';
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(examDate);
  if (!match) return '';
  const [, year, month, day] = match;
  return `${day}/${month}/${year}`;
}
